import { reactive, toRefs } from '@vue/composition-api'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default function useNodeSearch() {
  const state = reactive({
    searchOptions: null
  })

  async function searchNodes(query) {
    if(!query) return
    const { data } = await httpService.get(`search/model-hierarchy`, { query })
    state.searchOptions = _.map(data.data, item => ({
      label: item.name,
      value: item
    }))
  }

  async function clearSearchOptions() {
    state.searchOptions = null
  }

  return {
    ...toRefs(state),
    searchNodes,
    clearSearchOptions
  }
}
